import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  IconButton,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
  Radio,
  RadioGroup,
  FormControl,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import {REST_API_END_POINT} from '../../../constants/Defaultvalues';
import { Delete, KeyboardBackspaceOutlined, QrCodeScanner } from '@material-ui/icons';
import Scrollbar from 'src/components/Scrollbar';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import { Html5QrcodeScanner } from 'html5-qrcode';

const VALUE = [
  { id: 0, value: 'Material ID' },
  { id: 1, value: 'Materials' },
  { id: 2, value: 'Unit Cost' },
  { id: 3, value: 'Quantity' },
  // { id: 6, value: 'Shipping Per Item' },
  { id: 4, value: 'Sub total' },
  { id: 5, value: '' }
]
const VALUEStockCatalog = [
  { id: 0, value: 'Catalog ID' },
  { id: 1, value: 'Catalogs' },
  { id: 2, value: 'Unit Cost' },
  // { id: 3, value: 'Stock' },
  { id: 6, value: 'Quantity' },
  // { id: 9, value: 'Shipping Per Item' },
  { id: 7, value: 'Sub total' },
  { id: 8, value: '' }
]

export default function EditReceiveOrders() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const orderId = searchParams.get('id');
  const [vendors, setVendors] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [productsDatafilter, setProductsDatafilter] = useState([]);
  const [editData, setEditData] = useState([]);
  const [orderData, setOrderData] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [taxValue,setTaxValue] = useState(null)
  const currentDate = moment().format('MM-DD-YYYY');
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const userType = userData.user_type
  const [stockCatalogs,setStockCatalogs] = useState([])
  const [selectedStockCatalog,setSelectedStockCatalog] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [productType,setProductType] = useState('materials')
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const [openCatalogQRScanner, setOpenCatalogQRScanner] = useState(false);
  const [loading, setLoading] = useState(!!orderId);
  const scannerRef = useRef(null);
  const catalogScannerRef = useRef(null);
  let totalAmount = 0;
  
  const handleback = () => {
    window.history.back()
  }

  // const handleProduct = (value) => {
  //   const productsWithQuantity = value.map((product) => ({
  //     ...product,
  //     qty: selectedProducts.filter((p) => p.id === product.id)[0]?.qty || 0,
  //     unit_cost: selectedProducts.filter((p) => p.id === product.id)[0]?.unit_cost || 0,     
  //   }));
  //   // console.log('productsWithQuantity*****',productsWithQuantity);
  //   setSelectedProducts(productsWithQuantity);
  // };
  const handleProduct = async (value) => {
    const productsWithQuantity = await Promise.all(value.map(async (product) => {
      const existing = selectedProducts.find((p) => p.id === product.id);
      
      // If vendor is selected and material doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || existing?.unit_cost || 0;
      if (values.vendor && !existing?.unitCost && !existing?.unit_cost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: product.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...product,
        quantity: existing?.quantity || existing?.qty || 0,
        qty: existing?.qty || existing?.quantity || 0,
        unitCost: unitCost,
        unit_cost: unitCost, // Also set unit_cost for compatibility with existing data structure
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null
      };
    }));
    setSelectedProducts(productsWithQuantity);
  };

  const handleStockCatalog = async (value) => {
    const stockCatalogsWithQuantity = await Promise.all(value.map(async (stockCatalog) => {
      const existing = selectedStockCatalog.find((p) => p.id === stockCatalog.id);
      
      // If vendor is selected and catalog doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || existing?.unit_cost || 0;
      if (values.vendor && !existing?.unitCost && !existing?.unit_cost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: stockCatalog.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...stockCatalog,
        quantity: existing?.quantity || existing?.qty || 0,
        qty: existing?.qty || existing?.quantity || 0,
        unitCost: unitCost,
        unit_cost: unitCost, // Also set unit_cost for compatibility with existing data structure
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null
      };
    }));
    setSelectedStockCatalog(stockCatalogsWithQuantity);
  };

  const handleService = (value) => {
    const servicesWithPrice = value.map((service) => {
      const existing = selectedServices.find((s) => s.id === service.id);
      return {
        ...service,
        total_cost: existing?.total_cost || service.total_cost || 0
      };
    });
    setSelectedServices(servicesWithPrice);
    
    // Calculate sub_total
    let newTotalAmount = 0;
    servicesWithPrice.forEach(service => {
      newTotalAmount += parseFloat(service?.total_cost || 0);
    });
    const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
    setFieldValue('sub_total', Number(fixedTotal));
  };

  // const calculateTotal = (price, qty) => {
  //   const parsedPrice = parseFloat(price) || 0;
  //   const parsedQuantity = parseFloat(qty) || 0;
  //   const subtotal = parsedPrice * parsedQuantity;
  //   return parseFloat(subtotal.toFixed(2));
  // };
  const calculateTotal = (price, qty, shipping = 0, serviceCost = 0) => {
  const parsedPrice = parseFloat(price) || 0;
  const parsedQuantity = parseFloat(qty) || 0;
  const parsedShipping = parseFloat(shipping) || 0;
  const parsedService = parseFloat(serviceCost) || 0;
  const subtotal = (parsedPrice * parsedQuantity) + (parsedShipping * parsedQuantity) + parsedService;
  return parseFloat(subtotal.toFixed(2));
};
  const calculateGrandTotal = (subtotal) => {
  const includeTax = values.includeTax === 1;
  // let taxAmount = 0;
  const taxAmount = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (subtotal * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  // if (includeTax) {
  //   taxAmount = subtotal * taxPercentage / 100;
  // }
  return subtotal + taxAmount;
};

  const handleDeleteProduct = (productId,type) => {
    // Check if it's a material, catalog, or service
    const isMaterial = type == 1;
    const isCatalog = type == 0;
    const isService = type == 2;
    
    let filteredProducts = selectedProducts;
    let filteredCatalogs = selectedStockCatalog;
    let filteredServices = selectedServices;
    
    if (isMaterial) {
      filteredProducts = selectedProducts.filter(data => data.id !== productId);
      setFieldValue('products', filteredProducts);
      setSelectedProducts(filteredProducts);
    } else if (isCatalog) {
      filteredCatalogs = selectedStockCatalog.filter(data => data.id !== productId);
      setFieldValue('stockCatalogs', filteredCatalogs);
      setSelectedStockCatalog(filteredCatalogs);
    } else if (isService) {
      // Service deletion
      filteredServices = selectedServices.filter(data => data.id !== productId);
      setFieldValue('services', filteredServices);
      setSelectedServices(filteredServices);
    }

    // Recalculate total for materials, catalogs, and services using filtered arrays
    let newTotalAmount = 0;
    
    // Calculate materials total
    filteredProducts.forEach(product => {
      const subtotal = calculateTotal(
        product.unit_cost,
        product.qty,
        product.shipping_cost,
        product.services?.total_cost ?? serviceData.find(s => s.id === product.service_id)?.total_cost
      );
      newTotalAmount += subtotal;
    });
    
    // Calculate catalogs total
    filteredCatalogs.forEach(product => {
      const subtotal = calculateTotal(
        product.unit_cost,
        product.qty,
        product.shipping_cost,
        product.services?.total_cost ?? serviceData.find(s => s.id === product.service_id)?.total_cost
      );
      newTotalAmount += subtotal;
    });

    // Calculate services total
    filteredServices.forEach(service => {
      newTotalAmount += parseFloat(service?.total_cost || 0);
    });
    
    let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
    setFieldValue('sub_total', Number(fixedAmount));
    setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
  };

  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    color: theme.palette.text.primary,
  }))
  
  const fetchVendors = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}clients/getAllClients`,{userId,userType,isVendor:1})
      if(response.data.status === 1){
        const vendors = response?.data?.customer
        setVendors(vendors);
       
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }

  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  // const fetchTaxCategory = async () => {
  //   try{
  //     const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
  //     if(response.data.status === 1){
  //       const tax = response.data.taxResult?.find((option) => option.name = 'tax')
  //       if(tax){
  //         setTaxPercentage(tax.value);
  //       }
  //       else{
  //         setTaxPercentage(0);
  //       }
  //     }
  //   }
  //   catch(error){
  //     console.log("Error - ",error);
  //   }
  // }

  const fetchProducts = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-materials`,{userId,userType,
        isVendor:1,bringStockCatalog:1})
      if(response.data.status === 1){
        // setProductsData(response.data.results);
        setProductsDatafilter(response.data.results);
        setServiceData(response?.data?.allServices)
        setStockCatalogs(response?.data?.stockCatalogs)
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }

  const fetchOrderDataById = async () => {
    setLoading(true);
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-order-by-id`,{orderId})
      // if(response.data.status === 1){
      //   setEditData(response.data.prodData);
      //   setSelectedProducts(response.data.prodData)
      // }
      let allServices = response?.data?.allServices
      if(allServices && allServices.length > 0) {
        allServices.forEach(data => {
          data.original_total_cost = data?.total_cost || 0;
        });
      }
      setServiceData(allServices)
      if (response.data.status === 1) {
        // Store orderData for use in initialValues
        if (response.data.orderData && response.data.orderData.length > 0) {
          setOrderData(response.data.orderData[0]);
        }
        
        const serviceMap = Object.fromEntries(allServices?.map(s => [s.id, s]));
        let prodDataWithServices = (response.data.prodData || []).map(item => ({
          ...item,
          services: item.services || serviceMap[item.service_id] || null
        }));
        if(prodDataWithServices.length > 0) {
          prodDataWithServices.forEach(data => {
            if((data.service_id == data?.services?.id) && data.services) {
              data.services.total_cost = data?.service_cost || 0;
            }
          });
        }
        
        // Handle orderServices from receive_order_services table
        let orderServicesData = [];
        if (response.data.orderServices && response.data.orderServices.length > 0) {
          orderServicesData = response.data.orderServices.map(service => {
            const serviceInfo = serviceMap[service.service_id] || {};
            // Use price from receive_order_services table (saved price), not the original service total_cost
            // The price field comes from ros.price in the receive_order_services table
            // This is the price that was saved when the order was created
            const savedPrice = parseFloat(service.price) || 0;
            return {
              ...serviceInfo, // Spread service info first (includes original total_cost which we'll override)
              id: service.service_id,
              name: serviceInfo.name || service.name,
              description: serviceInfo.description || '',
              total_cost: savedPrice, // Override with saved price from receive_order_services.price
              syncWithQuickbooks: serviceInfo.syncWithQuickbooks || 0
            };
          });
        }
        
        // Determine order type: 1 = materials, 2 = stockCatalog, 3 = serviceOnly
        // Use orderData if available, otherwise use prodDataWithServices
        const orderTypeValue = (response.data.orderData && response.data.orderData[0]?.orderType) || prodDataWithServices[0]?.orderType;
        let orderType = 'materials';
        if (orderTypeValue == 2) {
          orderType = 'stockCatalog';
        } else if (orderTypeValue == 3) {
          orderType = 'serviceOnly';
        }
        setProductType(orderType);
        setEditData(prodDataWithServices);
        let materialData = prodDataWithServices.filter(item => item.meterial == 1)
        let catalogData = prodDataWithServices.filter(item => item.meterial == 0)
        // Use orderServicesData if available, otherwise fallback to prodDataWithServices
        let serviceData = orderServicesData.length > 0 ? orderServicesData : prodDataWithServices.filter(item => item.meterial == 2 || (!item.meterial && orderType == 'serviceOnly'))
        setSelectedProducts(materialData)
        setSelectedStockCatalog(catalogData)
        setSelectedServices(serviceData)
        // setSelectedProducts(prodDataWithServices);
      }
  }catch(error){
      console.log("Error - ",error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    fetchVendors();
    fetchTaxCategory()
    fetchProducts()
    if(orderId){
        fetchOrderDataById()
    } else {
        setLoading(false);
    }
  },[orderId])



  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    vendor: Yup.string().required('Vendor name is required'),
    receivedDate: Yup.date(),
    expectedDate: Yup.date(),
    // transactionId: Yup.string().required('Transaction ID is required'),
    products: productType === "materials" && Yup.array().min(1,'Please select atleast one product'),
    stockCatalogs: productType === "stockCatalog" && Yup.array().min(1,'Please select atleast one catalog'),
    services: productType === "serviceOnly" && Yup.array().min(1,'Please select atleast one service'),
  });
  
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));


  useEffect(() => {
    if (taxCategories.length > 0) {
      const taxCategoryId = orderData?.tax_category || (editData.length > 0 ? editData[0]?.tax_category : null);
      if (taxCategoryId) {
        const matchingCategory = taxCategories.find(cat => taxCategoryId === cat.id);
        setSelectedTaxCategory(matchingCategory || null);
        console.log('matchingCategorymatchingCategory',matchingCategory,taxCategoryId)
      }
    }
  }, [editData, taxCategories, orderData]);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: orderData?.order_name || editData[0]?.order_name || '',
      vendor: orderData?.vendor_id || editData[0]?.vendor_id || '',
      transactionId: orderData?.transaction_id || editData[0]?.transaction_id || '',
      receivedDate: (orderData?.received_date && moment.unix(orderData?.received_date).format('MM-DD-YYYY')) || (editData[0]?.received_date && moment.unix(editData[0]?.received_date).format('MM-DD-YYYY')) || null,
      expectedDate: (orderData?.expected_date && moment.unix(orderData?.expected_date).format('MM-DD-YYYY')) || (editData[0]?.expected_date && moment.unix(editData[0]?.expected_date).format('MM-DD-YYYY')) || null,
      includeTax: orderData?.include_tax || editData[0]?.include_tax || 0,
      products: editData.filter(item => item.meterial == 1) || [],
      stockCatalogs: editData.filter(item => item.meterial == 0) || [],
      services: selectedServices || [],
      tax: orderData?.tax || editData[0]?.tax || 0,
      sub_total: orderData?.sub_total || editData[0]?.sub_total || 0,
      grand_total: orderData?.grand_total || editData[0]?.grand_total || 0,
      taxCategory: orderData ? (taxCategories?.find(cat => orderData?.tax_category === cat.id) || null) : (editData[0]? taxCategories?.find(cat => editData[0]?.tax_category === cat.id) || null :[]),
      orderType: orderData ? (orderData.orderType == 1 ? 'materials' : (orderData.orderType == 3 ? 'serviceOnly' : 'stockCatalog')) : (editData[0] ? (editData[0].orderType == 1 ? 'materials' : (editData[0].orderType == 3 ? 'serviceOnly' : 'stockCatalog')) : 'materials')
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        values.taxCategory= selectedTaxCategory?.id
        values.products = selectedProducts
        values.stockCatalogs = selectedStockCatalog
        values.services = selectedServices
        // console.log('selectedProducts-------',selectedProducts);
        const hasErrors = selectedProducts.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity || product.unit_cost === 0 || product.qty === 0 || !product.unit_cost || !product.qty);
        const hasErrorsInCatalog = selectedStockCatalog.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity || product.unit_cost === 0 || product.qty === 0 || !product.unit_cost || !product.qty);
        const hasErrorsInServices = selectedServices.some(service => !service.total_cost || service.total_cost === 0 || parseFloat(service.total_cost) <= 0);
        if(hasErrors){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for material', { variant: 'error' });
        }else if(hasErrorsInCatalog){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for catalog', { variant: 'error' });
        }else if(hasErrorsInServices){
          enqueueSnackbar('Please enter valid price for all services', { variant: 'error' });
        }else{
          const response = await axios.post(`${REST_API_END_POINT}product/edit-receive-order`,{values,userId,orderId})
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' });
          }
          else {
            enqueueSnackbar('Failed to update order', { variant: 'error' });
          }
          resetForm();
          setSubmitting(false);
          navigate(PATH_DASHBOARD.receiveOrder.root);
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  const handleSearchMaterialByQR = useCallback(async (materialBarcode) => {
    try {
      if (!materialBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: materialBarcode,
        userId,
        userType,
        isMaterial: true
      });

      if (response.data.status === 1) {
        const productListData = response.data.results;
        if (productListData && productListData.length > 0) {
          const currentValues = formik.values;
          
          const filteredProducts = productListData.filter(product => {
            if (!currentValues.vendor) return true;
            const vendorIds = product?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString()) && product.inhouse == 1;
          });

          if (filteredProducts.length > 0) {
            const materialToAdd = filteredProducts[0];
            const isAlreadySelected = selectedProducts.some(p => p.id === materialToAdd.id);
            
            if (!isAlreadySelected) {
              const newProducts = [...currentValues.products, materialToAdd];
              setFieldValue('products', newProducts);
              handleProduct(newProducts);
            }
            
            enqueueSnackbar('Material found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Material not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Material not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Material not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching material by QR:", error);
      enqueueSnackbar('Error searching material', { variant: 'error' });
    }
  }, [formik, selectedProducts, setFieldValue, handleProduct, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              handleSearchMaterialByQR(decodedText);
              setOpenQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner, handleSearchMaterialByQR]);

  const handleSearchCatalogByQR = useCallback(async (catalogBarcode) => {
    try {
      if (!catalogBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: catalogBarcode,
        userId,
        userType,
        isMaterial: false
      });

      if (response.data.status === 1) {
        const catalogListData = response.data.results;
        if (catalogListData && catalogListData.length > 0) {
          const currentValues = formik.values;
          
          const filteredCatalogs = catalogListData.filter(catalog => {
            if (!currentValues.vendor) return true;
            const vendorIds = catalog?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString());
          });

          if (filteredCatalogs.length > 0) {
            const catalogToAdd = filteredCatalogs[0];
            const isAlreadySelected = selectedStockCatalog.some(c => c.id === catalogToAdd.id);
            
            if (!isAlreadySelected) {
              const newCatalogs = [...currentValues.stockCatalogs, catalogToAdd];
              setFieldValue('stockCatalogs', newCatalogs);
              handleStockCatalog(newCatalogs);
            }
            
            enqueueSnackbar('Catalog found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Catalog not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Catalog not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Catalog not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching catalog by QR:", error);
      enqueueSnackbar('Error searching catalog', { variant: 'error' });
    }
  }, [formik, selectedStockCatalog, setFieldValue, handleStockCatalog, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openCatalogQRScanner) {
      setTimeout(() => {
        if (!catalogScannerRef.current) {
          catalogScannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          catalogScannerRef.current.render(
            (decodedText) => {
              handleSearchCatalogByQR(decodedText);
              setOpenCatalogQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (catalogScannerRef.current) {
        catalogScannerRef.current.clear();
        catalogScannerRef.current = null;
      }
    };
  }, [openCatalogQRScanner, handleSearchCatalogByQR]);

  const updateGrandTotal = () => {
    const subtotal = values.sub_total || 0;
    // const grandTotal = calculateGrandTotal(subtotal);
    // const grandTotal = parseFloat(calculateGrandTotal(subtotal).toFixed(2));
    const taxAmount = selectedTaxCategory 
    ? (selectedTaxCategory.type === 1 
        ? (values.sub_total * (selectedTaxCategory.value || 0) / 100) 
        : (selectedTaxCategory.value || 0)) 
    : 0;

const fixedTaxAmount = parseFloat(taxAmount).toFixed(2);

const subTotal = parseFloat(values.sub_total || 0).toFixed(2);
// const grandTotal = Number(subTotal) + Number(fixedTaxAmount);
const grandTotal = (Number(subTotal) + Number(fixedTaxAmount)).toFixed(2);


setFieldValue('tax', Number(fixedTaxAmount))
    setFieldValue('grand_total', Number(grandTotal));
  };
  
  // Update grand total whenever sub_total changes
  useEffect(() => {
    updateGrandTotal();
  }, [values.sub_total, productType]);

  const handleSwitchChange = (event) => {
    const includeTax = event.target.checked;
    let taxAmount = 0;
    if (includeTax) {
      taxAmount = values.sub_total * taxPercentage / 100;
    }
    const grandTotal = values.sub_total + taxAmount;
    setFieldValue('includeTax', includeTax ? 1 : 0);
    setFieldValue('tax', includeTax ? taxPercentage : 0);
    setFieldValue('grand_total', grandTotal);
  };

  const handleTaxCategoryChange = (newValue)=>{
    const taxAmount = newValue ? (newValue.type === 1 ? (values.sub_total * (newValue.value || 0) / 100) : (newValue.value || 0) ) : 0;
    let fixedAmount =parseFloat(taxAmount).toFixed(2)
    setFieldValue('tax', Number(fixedAmount));
    let subTotal =parseFloat(values.sub_total).toFixed(2)
    // const grandTotal = Number(subTotal) + Number(fixedAmount)
    const grandTotal = (Number(subTotal) + Number(fixedAmount)).toFixed(2);
    setFieldValue('grand_total', Number(grandTotal));
  }
  const handleVendorChange = (event, newValue) => {  
    if(newValue){
      // const confirmReset = window.confirm(
      //   "Changing the vendor will remove all selected materials and reset related data. Do you want to continue?"
      // );
      // if (!confirmReset) return; 
  
      setSelectedProducts([]);
      setFieldValue('products', []);
      setFieldValue('sub_total', 0);
      setFieldValue('grand_total', 0);
      setFieldValue('tax', 0);
      const selectedOption = vendors?.find(option => option.id === newValue.id)
      if(selectedOption){
        setFieldValue('vendor', newValue?.id);
        const newFilteredProductsOne = productsDatafilter.filter(product => {
          const vendorIds = product?.vendor_id?.split(',').map(id => id.trim());
          return vendorIds?.includes(newValue?.id?.toString());
        });
        const newFilteredProducts = newFilteredProductsOne?.filter(item=>item.inhouse == 1)
        console.log("Filtered Products:", newFilteredProducts);
        setProductsData(newFilteredProducts);
      }else {
        setFieldValue('vendor', '');
      }
    }else {
      setFieldValue('vendor', '')
    }
  };
  useEffect(() => {
    if (editData.length > 0 && editData[0]?.vendor_id && productsDatafilter.length > 0) {
      const vendorId = editData[0]?.vendor_id;
      const newFilteredProductsOne = productsDatafilter?.filter(product => {
        const vendorIds = product?.vendor_id?.split(',').map(id => id.trim());
        return vendorIds?.includes(vendorId?.toString());
      });
      const initialFilteredProducts = newFilteredProductsOne?.filter(item=>item.inhouse == 1)
      setProductsData(initialFilteredProducts);
    }
  }, [editData, productsDatafilter]);
  
  useEffect(()=>{
    let totalAmount = 0
    
    // Calculate total for materials
    selectedProducts?.map((data, index) => {
      const rowTotal = calculateTotal(
        data.unit_cost,
        data.qty,
        data.shipping_cost,
        data.services?.total_cost ?? serviceData.find(s => s.id === data.service_id)?.total_cost
      );
      // Accumulate the totalAmount
      totalAmount += rowTotal;
    })
    
    // Calculate total for catalogs
    selectedStockCatalog?.map((data, index) => {
      const rowTotal = calculateTotal(
        data.unit_cost,
        data.qty,
        data.shipping_cost,
        data.services?.total_cost ?? serviceData.find(s => s.id === data.service_id)?.total_cost
      );
      // Accumulate the totalAmount
      totalAmount += rowTotal;
    })

    // Calculate total for services
    selectedServices?.forEach(service => {
      totalAmount += parseFloat(service?.total_cost || 0);
    });
    
    const fixedTotal = parseFloat(totalAmount).toFixed(2);
    setFieldValue('sub_total', fixedTotal);
  },[selectedProducts, selectedStockCatalog, selectedServices])

  return (
    <Page title="Edit Order | LOLDAO SUPPORT">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs heading=" Edit Order" />
          <Button
            variant="outlined"
            type="submit"
            onClick={() => handleback()}
            sx={{ alignItems: 'right' }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
        </Stack>
        {loading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '400px' }}>
            <CircularProgress size={60} />
            <Typography variant="body1" sx={{ mt: 2 }}>Loading order data...</Typography>
          </Stack>
        ) : (
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3} justifyContent="center" alignItems="center">
                <Grid item xs={12} md={11}>
                  <Card sx={{ p: 10, margin: 'auto',height: 'fit-content' }}>
                    <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                            fullWidth
                            label="Name"
                            type="text"
                            {...getFieldProps('name')}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                        />
                        <Autocomplete
                            select
                            fullWidth
                            id="vendor"
                            options={vendors}
                            getOptionLabel={(option) => option.name}
                            value = {vendors?.find((option) => option.id === values.vendor) || null}
                            onChange={handleVendorChange}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {option.syncWithQuickBook === 1 ? (
                                   <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                  ) : (
                                    <Avatar  sx={{ width: 30, height: 30, objectFit: "cover"}}/>
                                  )}
                                  <span>{option.name}</span>
                                </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select vendor"
                                fullWidth
                                SelectProps={{ native: true }}
                                error={Boolean(touched.vendor && errors.vendor)}
                                helperText={touched.vendor && errors.vendor}
                            />
                            )}
                        />
                    </Stack>
                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                        fullWidth
                        label="Transaction ID"
                        {...getFieldProps('transactionId')}
                        error={Boolean(touched.transactionId && errors.transactionId)}
                        helperText={touched.transactionId && errors.transactionId}
                    />
                    </Stack> */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box
                        component={MobileDatePicker}
                        label="Date Received"
                        maxDate={currentDate}
                        value={values.receivedDate}
                        onChange={(date) => setFieldValue('receivedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                      <Box
                        component={MobileDatePicker}
                        label="Date Expected"
                        minDate={values.expectedDate || currentDate}
                        value={values.expectedDate}
                        onChange={(date) => setFieldValue('expectedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          value={values.orderType}
                          onChange={(event) => {
                            setFieldValue('orderType', event.target.value)
                            setFieldValue('sub_total', 0)
                            setFieldValue('tax', 0);
                            setSelectedTaxCategory(null);
                            setFieldValue('grand_total', 0);
                            setProductType(event.target.value)
                            if(event.target.value === 'materials'){
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'stockCatalog'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'serviceOnly'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                            }
                          }}
                        >
                          <FormControlLabel
                            value="materials"
                            control={<Radio color="primary" />}
                            label="MATERIALS"
                          />
                          <FormControlLabel
                            value="stockCatalog"
                            control={<Radio color="primary" />}
                            label="STOCK CATALOGS"
                          />
                          <FormControlLabel
                            value="serviceOnly"
                            control={<Radio color="primary" />}
                            label="SERVICE ONLY"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                    <Divider />
                    {
                      productType == "materials" && (
                        <>
                    <LabelStyleHead>Materials</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          fullWidth
                          multiple
                          id="combo-box-demo"
                          // options={productsData || []}
                          options={productsData.filter(product => !selectedProducts.some(selected => selected.id === product.id)) || []}
                          value={values.products}
                          onChange={async (event, newValue) => {
                            if (!newValue || newValue.length === 0) {
                              setFieldValue('products', newValue);
                              setSelectedProducts([]);
                              setFieldValue('sub_total', 0);
                              setFieldValue('grand_total', 0);
                            } else {
                              setFieldValue('products', newValue);
                              await handleProduct(newValue);
                            }
                          }}
                          // getOptionLabel={(option) => option.name ? option.name : ''}
                          // // getOptionSelected={(option, value) => option.material_id === value.material_id}
                          // // isOptionEqualToValue={(option, value) => option.material_id === value.material_id}
                          // renderInput={(params) => (
                          //   <TextField {...params} required fullWidth
                          //   error={Boolean(touched.products && errors.products)}
                          //   helperText={touched.products && errors.products} 
                          //   label="Select material" />
                          // )}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => {
                            const name = option.name || '';
                            const description = option.description || '';
                            return `${description} \u200B${name}`.trim(); // combines both for search
                          }}
                          renderOption={(props, option) => {
                            const description = option.description || '';
                            return (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {option.syncWithQuickbooks === 1 && (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                  )}
                                  <Tooltip title={description}>
                                    <span style={{
                                      display: 'inline-block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '300px'
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </Box>
                              </li>
                            );
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const tooltipText = `${option.description || ''}`;
                              return (
                                <Tooltip key={index} title={tooltipText}>
                                  <Chip
                                    {...getTagProps({ index })}
                                    label={option.description || ''}
                                  />
                                </Tooltip>
                              );
                            })
                          }
                          filterOptions={(options, { inputValue }) =>
                            options.filter((option) => {
                              const searchText = inputValue.toLowerCase();
                              return (
                                option.name?.toLowerCase().includes(searchText) ||
                                option.description?.toLowerCase().includes(searchText)
                              );
                            })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              fullWidth
                              error={Boolean(touched.products && errors.products)}
                              helperText={touched.products && errors.products}
                              label="Select material"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    <Tooltip title="Scan QR Code">
                                      <IconButton
                                        size="small"
                                        onClick={() => setOpenQRScanner(true)}
                                        sx={{ mr: 1 }}
                                      >
                                        <QrCodeScanner />
                                      </IconButton>
                                    </Tooltip>
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                            />
                          )}
                        />
                        <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
                          <DialogTitle>Scan QR Code</DialogTitle>
                          <DialogContent>
                            <div id="reader" style={{ width: "100%" }}></div>
                          </DialogContent>
                        </Dialog>
                      </Stack>
                      {(selectedProducts?.length > 0) &&
                      <>
                        <LabelStyle>Selected Materials</LabelStyle>
                        <TableContainer>
                          <Table size="small">
                              <TableHead>
                                <TableRow>
                                  {VALUE?.map((val) => (
                                    <TableCell key={val.id} sx={{ padding: '8px' }}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedProducts?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                   const shippingFieldName = `shipping_cost_${index}`;
                                  // const rowTotal = calculateTotal(values[unitCostFieldName], values[quantityFieldName]);
                                  // const rowTotal = calculateTotal(data.unit_cost, data.qty);
                                  const rowTotal = calculateTotal(
                                    data.unit_cost,
                                    data.qty,
                                    data.shipping_cost,
                                    data.services?.total_cost ?? serviceData.find(s => s.id === data.service_id)?.total_cost
                                  );
                                  console.log('rowTotal', rowTotal)
                                  // Accumulate the totalAmount
                                  // totalAmount += rowTotal;
                                  // const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  // values['sub_total'] = fixedTotal
                                  // values['sub_total'] = Number(totalAmount)
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell sx={{ padding: '8px' }}>{data.id}</TableCell>
                                      <TableCell sx={{ padding: '8px' }}>{data.name}</TableCell>
                                      {/* <TableCell>{data.unit_cost}</TableCell> */}
                                      <TableCell sx={{ padding: '8px' }}>
                                        <TextField required
                                          sx={{width:"80px"}}
                                          type='number'
                                          label="Unit Cost"
                                          value={Number(data.unit_cost)}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }
                                            
                                              // data['unit_cost'] = newValue || 0;
                                              const updated = [...selectedProducts];
                                              updated[index] = {
                                                ...updated[index],
                                                unit_cost: newValue || 0,
                                              };
                                              setSelectedProducts(updated);
                                              setFieldValue(unitCostFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ padding: '8px' }}>
                                        <TextField required
                                          sx={{width:"80px"}}
                                          type='number'
                                          label="Quantity"
                                          value={Number(data.qty)}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            const newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue === '' || newValue <= 0) {
                                                event.preventDefault();
                                                return;
                                              }
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              // data['qty'] = newValue || 0;
                                              const updated = [...selectedProducts];
                                                updated[index] = {
                                                  ...updated[index],
                                                  qty: newValue
                                                };
                                                setSelectedProducts(updated);
                                              setFieldValue(quantityFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField
                                          fullWidth
                                          required
                                          type="number"
                                          label="Shipping"
                                          value={Number(data.shipping_cost || 0)}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            const value = event.target.value;
                                            // data['shipping_cost'] = value;
                                            const updated = [...selectedProducts];
                                            updated[index] = {
                                              ...updated[index],
                                              shipping_cost: value || 0,
                                            };
                                            setSelectedProducts(updated);
                                            setFieldValue(`shipping_${index}`, value);
                                          }}
                                        />
                                      </TableCell> */}
                                      <TableCell sx={{ padding: '8px' }}> 
                                        {rowTotal}
                                        {/* {calculateTotal(values[unitCostFieldName], values[quantityFieldName])} */}
                                      </TableCell>
                                      <TableCell sx={{ padding: '8px' }}>
                                        <IconButton size="small" onClick={() => handleDeleteProduct(data.id,1)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-material-${data.id}`}>
                                    <TableCell colSpan={3} sx={{ padding: '8px' }}>
                                      <Autocomplete
                                      fullWidth
                                      id={`sub-material-autocomplete-${data.id}`}
                                      options={serviceData}
                                     value={data.services || serviceData.find(s => s.id === data.service_id) || null}
                                      onChange={(e, newValue) => {
                                        let updatedService = null;
                                        if(newValue) {
                                          updatedService = {
                                            ...newValue,
                                            total_cost: newValue.original_total_cost || newValue.total_cost || 0
                                          };
                                        }
                                        const updatedProducts = [...selectedProducts];
                                        updatedProducts[index].services = updatedService;
                                        updatedProducts[index].service_id = newValue?.id || null; // keep `service_id` in sync
                                        setSelectedProducts(updatedProducts);
                                      }}
                                      getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                      renderOption={(props, option) => (
                                        <li {...props}>
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {option.syncWithQuickbooks == 1 && (
                                              <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                            )}
                                            <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                          </Box>
                                        </li>
                                      )}
                                      renderInput={(params) => (
                                        <TextField {...params} required label="Select Service (optional)1" fullWidth />
                                      )}
                                    />
                                    </TableCell>
                                    <TableCell colSpan={4} sx={{ padding: '8px' }}>
                                      {data.services ? (
                                        <TextField
                                          sx={{width:"100px"}}
                                          type='number'
                                          label="Service Cost"
                                          value={data.services.total_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                              const newValue = event.target.value || 0;
                                              if (newValue < 1 && event.key === 'ArrowDown') {
                                                event.preventDefault(); 
                                              }
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === "" || newValue === "0") {
                                              newValue = "0";
                                            } else {
                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                  newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                              }
                                            }
                                            const updatedProducts = [...selectedProducts];
                                            if (updatedProducts[index].services) {
                                              updatedProducts[index].services.total_cost = newValue || 0;
                                            }
                                            setSelectedProducts(updatedProducts);
                                            
                                            // Recalculate sub_total
                                            let newTotalAmount = 0;
                                            updatedProducts.forEach(product => {
                                              const subtotal = calculateTotal(
                                                product.unit_cost,
                                                product.qty,
                                                product.shipping_cost,
                                                product.services?.total_cost ?? serviceData.find(s => s.id === product.service_id)?.total_cost
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            
                                            // Add stock catalogs total
                                            selectedStockCatalog.forEach(catalog => {
                                              const subtotal = calculateTotal(
                                                catalog.unit_cost,
                                                catalog.qty,
                                                catalog.shipping_cost,
                                                catalog.services?.total_cost ?? serviceData.find(s => s.id === catalog.service_id)?.total_cost
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            
                                            const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                            setFieldValue('sub_total', Number(fixedTotal));
                                          }}
                                        />
                                      ) : (
                                        <Typography variant='body1'>No service selected</Typography>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell colSpan={11} sx={{ padding: '4px' }}>
                                      <Divider />
                                    </TableCell>
                                  </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                      </>}
                      </>
                      )
                    }

                    {
                      productType == "stockCatalog" && (
                        <>

                      <LabelStyleHead>Stock Catalogs</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          fullWidth
                          multiple
                          id="combo-box-demo"
                          // options={productsData || []}
                          options={stockCatalogs.filter(product => !selectedStockCatalog.some(selected => selected.id === product.id)) || []}
                          value={values.stockCatalogs}
                          onChange={async (event, newValue) => {
                            if (!newValue || newValue.length === 0) {
                              setFieldValue('stockCatalogs', newValue);
                              setSelectedStockCatalog([]);
                              setFieldValue('sub_total', 0);
                              setFieldValue('grand_total', 0);
                            } else {
                              setFieldValue('stockCatalogs', newValue);
                              await handleStockCatalog(newValue);
                            }
                          }}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          getOptionLabel={(option) => {
                            const name = option.name || '';
                            const description = option.description || '';
                            return `${description} \u200B${name}`.trim(); // combines both for search
                          }}
                          renderOption={(props, option) => {
                            const description = option.description || '';
                            return (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {option.syncWithQuickbooks === 1 && (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                  )}
                                  <Tooltip title={description}>
                                    <span style={{
                                      display: 'inline-block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '300px'
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </Box>
                              </li>
                            );
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const tooltipText = `${option.description || ''}`;
                              return (
                                <Tooltip key={index} title={tooltipText}>
                                  <Chip
                                    {...getTagProps({ index })}
                                    label={option.description || ''}
                                  />
                                </Tooltip>
                              );
                            })
                          }
                          filterOptions={(options, { inputValue }) =>
                            options.filter((option) => {
                              const searchText = inputValue.toLowerCase();
                              return (
                                option.name?.toLowerCase().includes(searchText) ||
                                option.description?.toLowerCase().includes(searchText)
                              );
                            })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              fullWidth
                              error={Boolean(touched.stockCatalogs && errors.stockCatalogs)}
                              helperText={touched.stockCatalogs && errors.stockCatalogs}
                              label="Select catalog"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    <Tooltip title="Scan QR Code">
                                      <IconButton
                                        size="small"
                                        onClick={() => setOpenCatalogQRScanner(true)}
                                        sx={{ mr: 1 }}
                                      >
                                        <QrCodeScanner />
                                      </IconButton>
                                    </Tooltip>
                                    {params.InputProps.endAdornment}
                                  </>
                                )
                              }}
                            />
                          )}
                        />
                        <Dialog open={openCatalogQRScanner} onClose={() => setOpenCatalogQRScanner(false)}>
                          <DialogTitle>Scan QR Code</DialogTitle>
                          <DialogContent>
                            <div id="reader" style={{ width: "100%" }}></div>
                          </DialogContent>
                        </Dialog>
                      </Stack>
                      {(selectedStockCatalog?.length > 0) &&
                      <>
                        <LabelStyle>Selected Catalogs</LabelStyle>
                        <TableContainer>
                          <Table size="small">
                              <TableHead>
                                <TableRow>
                                  {VALUEStockCatalog?.map((val) => (
                                    <TableCell key={val.id} sx={{ padding: '8px' }}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedStockCatalog?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                   const shippingFieldName = `shipping_cost_${index}`;
                                  // const rowTotal = calculateTotal(values[unitCostFieldName], values[quantityFieldName]);
                                  // const rowTotal = calculateTotal(data.unit_cost, data.qty);
                                  const rowTotal = calculateTotal(
                                    data.unit_cost,
                                    data.qty,
                                    data.shipping_cost,
                                    data.services?.total_cost ?? serviceData.find(s => s.id === data.service_id)?.total_cost
                                  );
                                  console.log('rowTotal', rowTotal)
                                  // Accumulate the totalAmount
                                  // totalAmount += rowTotal;
                                  // const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  // values['sub_total'] = fixedTotal
                                  // values['sub_total'] = Number(totalAmount)
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell sx={{ padding: '8px' }}>{data.id}</TableCell>
                                      <TableCell sx={{ padding: '8px' }}>{data.name}</TableCell>
                                      {/* <TableCell>{data.unit_cost}</TableCell> */}
                                      <TableCell sx={{ padding: '8px' }}>
                                        <TextField required
                                            sx={{width:"80px"}}
                                          type='number'
                                          label="Unit Cost"
                                          value={Number(data.unit_cost)}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }
                                            
                                              // data['unit_cost'] = newValue || 0;
                                              const updated = [...selectedStockCatalog];
                                              updated[index] = {
                                                ...updated[index],
                                                unit_cost: newValue || 0,
                                              };
                                              setSelectedStockCatalog(updated);
                                              setFieldValue(unitCostFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ padding: '8px' }}>
                                        <TextField required
                                          sx={{width:"80px"}}
                                          type='number'
                                          label="Quantity"
                                          value={Number(data.qty)}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            const newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue === '' || newValue <= 0) {
                                                event.preventDefault();
                                                return;
                                              }
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              // data['qty'] = newValue || 0;
                                              const updated = [...selectedStockCatalog];
                                                updated[index] = {
                                                  ...updated[index],
                                                  qty: newValue
                                                };
                                                setSelectedStockCatalog(updated);
                                              setFieldValue(quantityFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField
                                          fullWidth
                                          required
                                          type="number"
                                          label="Shipping"
                                          value={Number(data.shipping_cost || 0)}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            const value = event.target.value;
                                            // data['shipping_cost'] = value;
                                            const updated = [...selectedStockCatalog];
                                            updated[index] = {
                                              ...updated[index],
                                              shipping_cost: value || 0,
                                            };
                                            setSelectedStockCatalog(updated);
                                            setFieldValue(`shipping_${index}`, value);
                                          }}
                                        />
                                      </TableCell> */}
                                      <TableCell sx={{ padding: '8px' }}> 
                                        {rowTotal}
                                        {/* {calculateTotal(values[unitCostFieldName], values[quantityFieldName])} */}
                                      </TableCell>
                                      <TableCell sx={{ padding: '8px' }}>
                                        <IconButton size="small" onClick={() => handleDeleteProduct(data.id,0)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-material-${data.id}`}>
                                    <TableCell colSpan={3} sx={{ padding: '8px' }}>
                                      <Autocomplete
                                      fullWidth
                                      id={`sub-material-autocomplete-${data.id}`}
                                      options={serviceData}
                                     value={data.services || serviceData.find(s => s.id === data.service_id) || null}
                                      onChange={(e, newValue) => {
                                        let updatedService = null;
                                        if(newValue) {
                                          updatedService = {
                                            ...newValue,
                                            total_cost: newValue.original_total_cost || newValue.total_cost || 0
                                          };
                                        }
                                        const updatedProducts = [...selectedStockCatalog];
                                        updatedProducts[index].services = updatedService;
                                        updatedProducts[index].service_id = newValue?.id || null; // keep `service_id` in sync
                                        setSelectedStockCatalog(updatedProducts);
                                      }}
                                      getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                      renderOption={(props, option) => (
                                        <li {...props}>
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {option.syncWithQuickbooks == 1 && (
                                              <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                            )}
                                            <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                          </Box>
                                        </li>
                                      )}
                                      renderInput={(params) => (
                                        <TextField {...params} required label="Select Service (optional)" fullWidth />
                                      )}
                                    />
                                    </TableCell>
                                    <TableCell colSpan={4} sx={{ padding: '8px' }}>
                                      {data.services ? (
                                        <TextField
                                        sx={{width:"100px"}}
                                          type='number'
                                          label="Service Cost"
                                          value={data.services.total_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                              const newValue = event.target.value || 0;
                                              if (newValue < 1 && event.key === 'ArrowDown') {
                                                event.preventDefault(); 
                                              }
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === "" || newValue === "0") {
                                              newValue = "0";
                                            } else {
                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                  newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                              }
                                            }
                                            const updatedCatalogs = [...selectedStockCatalog];
                                            if (updatedCatalogs[index].services) {
                                              updatedCatalogs[index].services.total_cost = newValue || 0;
                                            }
                                            setSelectedStockCatalog(updatedCatalogs);
                                            
                                            // Recalculate sub_total
                                            let newTotalAmount = 0;
                                            
                                            // Add materials total
                                            selectedProducts.forEach(product => {
                                              const subtotal = calculateTotal(
                                                product.unit_cost,
                                                product.qty,
                                                product.shipping_cost,
                                                product.services?.total_cost ?? serviceData.find(s => s.id === product.service_id)?.total_cost
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            
                                            updatedCatalogs.forEach(catalog => {
                                              const subtotal = calculateTotal(
                                                catalog.unit_cost,
                                                catalog.qty,
                                                catalog.shipping_cost,
                                                catalog.services?.total_cost ?? serviceData.find(s => s.id === catalog.service_id)?.total_cost
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            
                                            const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                            setFieldValue('sub_total', Number(fixedTotal));
                                          }}
                                        />
                                      ) : (
                                        <Typography variant='body1'>No service selected</Typography>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell colSpan={11} sx={{ padding: '4px' }}>
                                      <Divider />
                                    </TableCell>
                                  </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                      </>}
                      </>
                      )
                    }

                    {
                      productType == "serviceOnly" && (
                        <>
                          <LabelStyleHead>Services</LabelStyleHead>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                              <Autocomplete
                                fullWidth
                                multiple
                                id="service-autocomplete"
                                options={serviceData?.filter(service => !selectedServices.some(selected => selected.id === service.id)) || []}
                                value={values.services}
                                onChange={(event, newValue) => {
                                  if (!newValue || newValue.length === 0) {
                                    setFieldValue('services', newValue);
                                    setSelectedServices([]);
                                    setFieldValue('sub_total', 0);
                                    setFieldValue('grand_total', 0);
                                  } else {
                                    setFieldValue('services', newValue);
                                    handleService(newValue);
                                  }
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                renderOption={(props, option) => (
                                  <li {...props}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      {option.syncWithQuickbooks == 1 && (
                                        <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                      )}
                                      <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                    </Box>
                                  </li>
                                )}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => {
                                    const tooltipText = `${option.description || ''} ${option.name || ''}`.trim();
                                    return (
                                      <Tooltip key={index} title={tooltipText}>
                                        <Chip
                                          {...getTagProps({ index })}
                                          label={`${option.description || ''} ${option.name || ''}`.trim()}
                                        />
                                      </Tooltip>
                                    );
                                  })
                                }
                                filterOptions={(options, { inputValue }) =>
                                  options.filter((option) => {
                                    const searchText = inputValue.toLowerCase();
                                    return (
                                      option.name?.toLowerCase().includes(searchText) ||
                                      option.description?.toLowerCase().includes(searchText)
                                    );
                                  })
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    fullWidth
                                    error={Boolean(touched.services && errors.services)}
                                    helperText={touched.services && errors.services}
                                    label="Select Services"
                                  />
                                )}
                              />
                            </Box>
                          </Stack>
                        </>
                      )
                    }

                    {(selectedServices?.length > 0) &&
                    <>
                      <LabelStyle>Selected Services</LabelStyle>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Service ID</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {selectedServices?.map((data, index) => {
                                const priceFieldName = `service_price_${index}`;
                                return (
                                  <>
                                    <TableRow key={data.id}>
                                      <TableCell>{data.id}</TableCell>
                                      <TableCell>{data.description || data.name}</TableCell>
                                      <TableCell>
                                        <TextField
                                          required
                                          fullWidth
                                          type='number'
                                          label="Price"
                                          sx={{width:"200px"}}
                                          value={data.total_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '') {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                              const newValue = event.target.value || 0;
                                              if (newValue < 1 && event.key === 'ArrowDown') {
                                                event.preventDefault(); 
                                              }
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === "" || newValue === "0") {
                                              newValue = "0";
                                            } else {
                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                  newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                              }
                                            }
                                            const updatedServices = [...selectedServices];
                                            updatedServices[index].total_cost = newValue || 0;
                                            setSelectedServices(updatedServices);
                                            
                                            // Recalculate sub_total
                                            let newTotalAmount = 0;
                                            updatedServices.forEach(service => {
                                              newTotalAmount += parseFloat(service?.total_cost || 0);
                                            });
                                            const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                            setFieldValue('sub_total', Number(fixedTotal));
                                          }}
                                          error={Boolean(touched[priceFieldName] && errors[priceFieldName])}
                                          helperText={touched[priceFieldName] && errors[priceFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <IconButton onClick={() => handleDeleteProduct(data.id, 2)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell colSpan={4} sx={{ padding: 0 }}>
                                        <Divider />
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                    </>}


                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                        {/* <FormControlLabel
                            control={
                                <Switch
                                    onChange={handleSwitchChange}
                                    checked={values.includeTax === 1}
                                    defaultChecked
                                />
                            }
                            label="Include Tax"
                        /> */}

                             <Autocomplete
                              // sx={{ width: 400 }}
                              fullWidth
                              id="combo-box-demo"
                              options={taxCategories || []}
                              value={selectedTaxCategory || null}
                              onChange={(event, newValue) => {
                                handleTaxCategoryChange(newValue)
                                setSelectedTaxCategory(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select tax category" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                      </Box>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Sub Total"
                          {...getFieldProps('sub_total')}
                          error={Boolean(touched.sub_total && errors.sub_total)}
                          helperText={touched.sub_total && errors.sub_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Tax (%)"
                          {...getFieldProps('tax')}
                          error={Boolean(touched.tax && errors.tax)}
                          helperText={touched.tax && errors.tax}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Grand Total"
                          {...getFieldProps('grand_total')}
                          error={Boolean(touched.grand_total && errors.grand_total)}
                          helperText={touched.grand_total && errors.grand_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                      </Stack>

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Save Changes
                      </LoadingButton>
                      <Button variant="outlined" onClick={()=>{handleback()}} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
        )}
      </Container>
    </Page>
  );
}